import { AvailabilityIssuePeriod } from "./PlantAvailability.types";

export const AVAILABILITY_DURATION = AvailabilityIssuePeriod.WEEKLY;

// Use *ODD* numbers to get symmetric (before and after) available years e.g 5 will result in available years: 
// currentYear-2, currentYear-1, currentYear, currentYear+1, currentYear+2,
export const AVAILABILITY_YEAR_SPAN = 5;
